import { ReactElement } from 'react';

export const PopoverTextWrapper = ({ children }: { children: ReactElement | string }) => {
  return (
    <p
      data-testid='tooltip--tooltip-message-container'
      className='m-1 rounded-md bg-inverse p-3 text-negative text-body-s max-w-xs dark:shadow-black-1000/30 dark:shadow-md'>
      {children}
    </p>
  );
};
